import lodashDebounce from 'lodash/throttle';

const setup = (store) => {
  const resizeCallback = () => {
    let breakpoint = '';
    if (window.innerWidth < 576) breakpoint = 'xs';
    else if (window.innerWidth >= 576 && window.innerWidth < 768) breakpoint = 'sm';
    else if (window.innerWidth >= 768 && window.innerWidth < 992) breakpoint = 'md';
    else if (window.innerWidth >= 992 && window.innerWidth < 1200) breakpoint = 'lg';
    else if (window.innerWidth > 1200) breakpoint = 'xl';
    
    let ismobile = window.innerWidth < 768;
    store.commit('setIsMobile', ismobile);
    store.commit('setResponsiveBreakPoint', breakpoint);
  };
  
  $(window).on('resize', lodashDebounce(resizeCallback, 200));
  resizeCallback();
};

export default setup;